import { Components, Theme } from "@mui/material"

export const MuiTableCell: Required<Components<Theme>>["MuiTableCell"] = {
  styleOverrides: {
    root: ({ theme: { uisk, typography } }) => ({
      ...typography["Text md/Regular"],
      border: "none",
      padding: uisk.spacing.sm,
      color: "unset", // allow specifying at higher levels like tablehead and tablerow
    }),
  },
}
